<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" style="display:block;"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" style="display:block;"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",

  watch: {
    //   '$route' () {
    //     let locationHash = window.location.hash;
    //     sessionStorage.setItem("hashLocation",locationHash);//把路由存在缓存中，此处你可以console.log看出路由变化
    //   }
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  border: none;
  // font-family: PingFangSC-Semibold, sans-serif;
}
#app {
  width: 100%;
  height: 100%;
  // overflow-y: scroll;
}
body {
  overflow-y: scroll;
}
html,
body {
  height: 100%;
  // -moz-user-select:none;
  // -webkit-user-select:none;
  // -ms-user-select:none;
  // user-select:none;
}
.library_content {
  a {
    display: block;
    color: #333;
    p {
      color: #333;
    }
    &:link,
    &:visited,
    &:hover,
    &:active {
      color: #333;
    }
  }
}
// 详情头部导航
.box {
  background: url("./assets/public/bg1.png");
  .nav {
    margin-left: -5px;
    margin-bottom: 30px;
    height: 20px;
    font-size: 14px;
    color: #999;
    a {
      color: #999;
      &:hover {
        color: #ff5833;
      }
      font-family: PingFangSC-Light, sans-serif;
      font-weight: 300;
    }
    span {
      font-family: PingFangSC-Light, sans-serif;
      font-weight: 300;
    }
    .nav_home {
      background: url("./assets/public/companyNews/home_icon@2x.png") no-repeat
        left center;
      background-size: 16px;
      padding-left: 22px;
    }
    .icon_nav,
    .icon_nav_active {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-top: -2px;
    }
    .nav_middle,
    .nav_middle_no {
      background: url("./assets/public/companyNews/next_icon@2x.png") no-repeat
        left center;
      background-size: 16px;
      padding-left: 20px;
      cursor: pointer;
    }
    .nav_book{
      cursor: pointer;
    }
    .nav_current,
    .nav_current_no {
      background: url("./assets/public/companyNews/next_icon@2x.png") no-repeat
        left center;
      background-size: 16px;
      padding-left: 20px;
      line-height: 20px;
      color: #ff5833;
      // display:inline-block;
      // width:100px;
      // display: -webkit-inline-box;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // word-wrap: break-word;
      // white-space: normal;
      // -webkit-line-clamp: 1;
      // -webkit-box-orient: vertical;
      // vertical-align: bottom;
    }
    .nav_current_no,
    .nav_middle_no {
      background: none;
      padding-left: 0;
    }
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0 80px;
    // display: flex;
  }
}
// 搜索页面和古籍分类页面 书排列样式
.book_lists {
  margin-bottom: 30px;
  display: inline-block;
  // display: flex;
  // display: -webkit-flex;
  // display: -moz-box;
  // display: -ms-flexbox;
  // flex-wrap: wrap;
  // justify-content: space-between;
  // align-content: flex-start;
  // align-items: flex-start;
  &::after {
    content: "";
    width: 240px;
    border: 1px solid transparent;
  }
  .list {
    width: 240px;
    text-align: center;
    line-height: 1;
    margin-top: 40px;
    display: inline-block;
    .image_box {
      width: 240px;
      height: 173px;
      cursor: pointer;
      position: relative;
      &:hover {
        box-shadow: 0px 1px 11px 1px rgba(0, 0, 0, 0.07);
      }
      .book_box {
        width: 95px;
        height: 119px;
        padding-top: 30px;
        margin-left: 71px;
        position: relative;
        .book {
          width: 100%;
        }
        .shadow {
          width: 127px;
          height: 145px;
          position: absolute;
          bottom: -17px;
          left: -10px;
        }
      }
      .scale_box {
        position: absolute;
        right: -240px;
        top: 30px;
        z-index: 100;
        .book_scale {
          width: 300px;
        }
        .shadow_scale {
          width: 390px;
          position: absolute;
          bottom: -24px;
          left: -20px;
        }
      }
    }
    .title {
      width: fit-content;
      margin: 0 auto;
      font-size: 16px;
      // font-family:FZGB10;
      font-family: PingFangSC-Medium, sans-serif;
      font-weight: 500;
      color: #333;
      margin-top: 10px;
      cursor: pointer;
    }
    .author,
    .remark {
      font-size: 13px;
      font-family: PingFangSC-Light, sans-serif;
      font-weight: 300;
      color: #999;
      margin-top: 11px;
    }
  }
}
// 图书详情页搜索框
.detail_search{
  // width: 842px !important;
  left: calc(50% - 465px) !important;
  margin-bottom: 30px !important;
  // .sea_input{
    // width: 842px !important;
  // }
}
// .left_side{
//   margin-top: 70px;
// }
// 评论输入框
.el-textarea__inner {
  min-height: 56px;
  padding-top: 18px;
  // width:844px;
  border-radius: 10px;
  // margin:30px auto 0;
  background-color: #fbfbfb;
  border: 1px solid #ddd;
  &:focus {
    outline: 0;
  }
}
#index .el-textarea__inner{
  height: 200px !important;
  border-radius:4px;
  padding-left: 20px;
  padding-top: 20px;
  font-family: PingFangSC-Regular;
}
// 查看更多
.more_info,
.no_more {
  font-size: 14px;
  color: #eb5b35;
  text-align: center;
  padding-bottom: 18px;
  font-family: PingFangSC-Light, sans-serif;
  font-weight: 300;
}
.more_info {
  img {
    width: 60px;
  }
}
.no_more {
  color: #666;
}
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s ease;
}
.slide-fade-enter, .slide-fade-leave-to
		/* .slide-fade-leave-active for below version 2.1.8 */ {
  // transform: translateX(10px);
  opacity: 0;
}

.swiper-button-prev,
.swiper-button-next {
  outline: none !important;
}
.swiper-container .swiper-pagination .swiper-pagination-bullet-active {
  background: #fa9964 !important;
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url(./assets/index/left.png) !important;
  background-size: cover !important;
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url(./assets/index/right.png) !important;
  background-size: cover !important;
}

.video-js .vjs-tech {
  pointer-events: none;
}
.askbox .ql-editor {
  min-height: 140px !important;
  max-height: 340px !important;
  font-size: 16px;
  //   border: 1px solid green !important;
}
.ql-toolbar.ql-snow {
  border: none !important;
}
.ql-toolbar.ql-snow .ql-formats {
  float: right !important;
  margin-right: 0px !important;
}
.askbox .ql-container.ql-snow {
  border: 2px solid rgba(173, 137, 107, 0.49) !important;
  border-radius: 10px !important;
  background: #fff;
}
.askbox .ql-toolbar.ql-snow + .askbox .ql-container.ql-snow {
  border-top: 2px solid rgba(173, 137, 107, 0.49) !important;
}
.askbox .ql-snow.ql-toolbar .ql-image,
.askbox .margin-top-20 .ke-toolbar .ke-toolbar-icon-url {
  width: 100%;
  height: 100%;
  background: url(./assets/community/image_icon.png) !important;
  cursor: pointer !important;
  background-size: cover;
  svg {
    display: none !important;
  }
}
.askbox .ke-content{
  font-size: 16px;
}
.askbox .margin-top-20 .ke-toolbar .ke-outline{
  background: none;
    border: none;
    cursor: pointer;
    display: inline-block;
    float: right;
    height: 24px;
    padding: 3px 5px;
    width: 28px;
}
.viewer-footer {
  display: none;
}
.el-loading-mask.is-fullscreen {
  z-index: 14000 !important; //因为我的header的z-index比较大。这里看情况
}
// loading
.my-el-custom-spinner {
  background: url("../static/loading.gif"); //这个图自己百度"loading gif"，肯定能找到
  background-size: 40px 40px; //长宽自己设置
  width: 38px;
  height: 7px;
  display: inline-block;
}
.el-loading-spinner {
  top: 40% !important; //这是控制loading位置的
}
// 面包屑
.el-breadcrumb {
  padding: 20px 0px;
  margin-left: 60px;
}
.el-breadcrumb__inner.is-link {
  font-weight: 400;
  color: #666 !important;
}
.el-breadcrumb__inner {
  color: #ff5833 !important;
}
.back {
  width: 70px;
  height: 30px;
  color: #ff5833;
  font-size: 18px;
  margin-bottom: 20px;
  cursor: pointer;
  span {
    display: inline-block;
    width: 28px;
    height: 28px;
    background: url(./assets/community/return_icon_nor.png) center center
      no-repeat;
    vertical-align: middle;
    margin-right: 5px;
  }
}
.box_booktags .back {
  margin-left: 35px;
}
.goback {
  display: inline-block;
  width: 70px;
  height: 20px;
  color: #ff5833;
  font-size: 14px;
  margin-bottom: 20px;
  cursor: pointer;
  span {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url(./assets/community/return_icon_nor.png) center center
      no-repeat;
    background-size: cover;
    vertical-align: middle;
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue